import * as turf from '@turf/turf';
export function clearPolygon(featureGroupRef: any, size = 0 as number) {
  const drawnItems = featureGroupRef._layers
  if (Object.keys(drawnItems).length > size) {
    Object.keys(drawnItems).forEach((layerid, index) => {
      if (index > 0) return
      const layer = drawnItems[layerid]
      return featureGroupRef.removeLayer(layer)
    })
  }
}

export function convertResponse(response) {
  const convert = {
    ...response,
    color: 'red',
    polygonCordinate: response?.polygon?.map((item) => [
      item.locLong,
      item.locLate,
    ]),
    // .sort((a, b) => a.polygonIndex - b.polygonIndex),
  }
  return convert
}

function renderColor(countryType){
   if (countryType === 5) return "green"
   if (countryType === 3) return "#dd2296"
   if (countryType === 4) return "#6d67e4"
}

export function convertSubZoneResponse(response) {
  const convert = {
    ...response,
    color:renderColor(response.countryType.id),
    polygonCordinate: response.polygone
      ? response.polygone.map((item) => [item.locLong, item.locLate])
      : null,
    // .sort((a, b) => a.polygonIndex - b.polygonIndex),
  }
  return convert
}




// export function getIntersectPolygon(
//   parentZone: number[][],
//   currentZone: number[][],
//   children: { polygonCordinate: number[][] | null }[]
// ): number[][] {
//   console.log(parentZone,currentZone,children)
//   try {
//     function fixPoly(coords: number[][]): turf.Feature<turf.Polygon> {
//       const closed = [...coords, coords[0]]
//       const poly = turf.polygon([closed])
//       turf.rewind(poly, { reverse: true })
//       return turf.buffer(poly, 0)
//     }
//     const mainPoly = fixPoly(parentZone)
//     const currPoly = fixPoly(currentZone)
//     let result: turf.Feature<turf.Polygon> | null = null
//     try {
//       result = turf.intersect(mainPoly, currPoly)
//     } catch {
//       result = null
//     }
//     if (!result) {
//       result = null
//       // result = currPoly;
//     }

//     const currKey = JSON.stringify(currentZone)
//     const otherChildren = children
//       .filter((c) => c.polygonCordinate)
//       .filter((c) => JSON.stringify(c.polygonCordinate) !== currKey)
//       .map((c) => fixPoly(c.polygonCordinate!))

//     for (const childPoly of otherChildren) {
//       try {
//         const diff = turf.difference(result, childPoly)
//         if (diff) result = diff
//       } catch {
//         toast.warning('منطقه بدرستی تعریف نشده است.')
//         return
//         // اگر توپو خطا داد، ردش کن
//       }
//     }

//     const coords = result.geometry.coordinates[0]
//     return coords
//   } catch {
//     toast.warning('منطقه بدرستی تعریف نشده است.')
//   }
// }






export function getIntersectPolygon(
  parentZone: number[][],
  currentZone: number[][],
  children: any[],
) {
  try {

  //  console.log(parentZone,currentZone,children)
    // تنظیمات پیشرفته برای دقت بالا
    const precisionOptions = {
      precision: 6,  // افزایش دقت به ۶ رقم اعشار
      coordinates: 6,
      mutate: true
    };
   
    // پاکسازی و آماده‌سازی پلیگان اصلی
    const mainPolyTurf = turf.cleanCoords(
      turf.rewind(turf.polygon([parentZone]), 
      { mutate: true }
    ))

    // پاکسازی و آماده‌سازی پلیگان جاری
    
    let currentPolyTurf = turf.truncate(
      turf.cleanCoords(
        turf.rewind(turf.polygon([currentZone]), 
        { mutate: true }
      ),
      precisionOptions
    ))


    const childs=structuredClone(children)
    childs.shift()
  


    const isFullyInsideChild = childs.some(child => {
      if (!child?.polygonCordinate) return false;
      const childPoly = turf.polygon([child.polygonCordinate]);
      return turf.booleanContains(childPoly, currentPolyTurf);
    });
 
    if (isFullyInsideChild) return 


    const childrens = childs
      .filter(item => item?.polygonCordinate?.length >= 3)
      .map(item => {
        const poly = turf.truncate(
          turf.cleanCoords(
            turf.rewind(turf.polygon([item.polygonCordinate])),
            { mutate: true }
          ),
          precisionOptions
        );
        return turf.simplify(poly, { tolerance: 0.0001, highQuality: true });
      });

    // محاسبه اشتراک با هندل خطا
    let intersection = turf.intersect(mainPolyTurf, currentPolyTurf);
    if (!intersection || turf.area(intersection) < 0.000001) return [];

    // // اعتبارسنجی نهایی
    // if (!booleanValid(intersection)) {
    //   intersection = turf.cleanCoords(intersection);
    // }

    // محاسبه تفاضل با فرزندان
    let finalPoly = intersection;
    
    for (const childPoly of childrens) {
      try {
        const diff = turf.difference(finalPoly, childPoly);

        if (diff && turf.area(diff) > 0.000001 && finalPoly !== null) {
          finalPoly = turf.truncate(diff, precisionOptions);
        }
      } catch (e) {
        console.warn('Skipping invalid difference operation:', e);
      }
    }



    if (finalPoly.geometry.type === 'MultiPolygon') {

      if (finalPoly.geometry.coordinates.length === 1) {
        finalPoly = turf.polygon(finalPoly.geometry.coordinates[0]);
      } 

      else {
        try {
          let merged = finalPoly.geometry.coordinates.reduce((acc, polygon) => {
            const poly = turf.polygon(polygon);
            return acc ? turf.union(acc, poly) : poly;
          }, null);
          if (merged && merged.geometry.type === 'Polygon') {
            finalPoly = merged;
          } else {
            throw new Error('Non-mergeable MultiPolygon');
          }
        } catch (e) {
          console.error('Merge failed:', e);
          return [];
        }
      }
    }

    if (turf.area(finalPoly) === 0) return [];
    if (finalPoly.geometry.type === 'MultiPolygon') {
      throw new Error('Result cannot be converted to single Polygon');
    }

    if (turf.area(finalPoly) ===0){
          return
    }
    return finalPoly.geometry.coordinates[0]
      .map(coord => [coord[0], coord[1]]);
  
  } catch (error) {
    console.error('Operation failed:', error);
    return [];
  }
}








